import { lazy } from 'react';
import { registerModuleRoute } from 'app/navigation/routeRegistry';
import { ModuleRoute } from 'app/navigation/routeRegistry';
import { CORE_SCREEN_NAMES } from './navigation/CoreNavigation';

const CoreNavigation = lazy(() => import('./navigation/CoreNavigation'));
const coreRoute: ModuleRoute = {
    id: 'core',
    Stack: CoreNavigation,
    meta: {
        placement: 'tab',
        tabLabel: 'Home',
        tabIcon: 'home',
        order: 10,
    },
    screenNames: CORE_SCREEN_NAMES,
};


registerModuleRoute(coreRoute);

export * from './components/home';
export * from './utils';
export * from './constants';
export { default as SplashScreen } from './screens/SplashScreen';
export { default as ForceUpdateModal } from './screens/ForceUpdateModal';